import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "container",
  style: {"align-content":"flex-start"}
}

import {nextTick, reactive, UnwrapRef, watch} from "vue";
import {getTreatDetailById} from "@/api/sale_order";
interface Item {
    amount: number,
    preloadAmount:number,
    treatName: string,
    paySubject: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'setAmount',
  props: {
    treatId: {
        type: String,
        default: ""
    },
},
  emits: ['selectChange'],
  setup(__props, { emit: emits }) {

const props = __props;




let item: UnwrapRef<Item> = reactive({
    amount: 0.00,
    preloadAmount: 0.00,
    treatName: "",
    paySubject: "",
});

watch(
    () => props.treatId, async () => {
        await nextTick(()=>{
            getTreatDetail(props.treatId);
        })
    },
    {
        immediate: true,
        deep: true,
    }
);
const paySubjectChange = (value: string)=>{
    console.log(item.paySubject)
    if(value){
        let res = {
            name: item.paySubject,
            type: 8
        }
        console.log(res,"开始回传")
        emits("selectChange",res)
    }
}
const amountChange = (value: string)=>{
    console.log(item.amount)
    if(value){
        let res = {
            amount: item.amount,
            type: 6
        }
        console.log(res,"开始回传")
        emits("selectChange",res)
    }
}

const preloadAmountChange = (value: string)=>{
    console.log(item.preloadAmount)
    if(value){
        let res = {
            amount: item.preloadAmount,
            type: 7
        }
        console.log(res,"开始回传")
        emits("selectChange",res)
    }
}
const getTreatDetail = (treatId: string)=>{
    getTreatDetailById(treatId).then((res: any)=>{
        item.treatName = res.treatName;
    })
}


return (_ctx: any,_cache: any) => {
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, { bordered: false }, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 8 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_card, {
                  style: {"height":"200px"},
                  title: "治疗项目"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_descriptions, {
                      size: "default",
                      column: 1
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_descriptions_item, { label: "治疗项目" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(item).treatName), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 8 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_card, {
                  style: {"height":"200px"},
                  title: "预计金额"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form, {
                      model: _unref(item),
                      autoComplete: "off",
                      ref: "refProcessForm"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: "请输入预计金额",
                          name: "name"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input_number, {
                              value: _unref(item).preloadAmount,
                              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(item).preloadAmount) = $event)),
                              style: {"width":"200px"},
                              defaultValue: 0,
                              precision: 2,
                              min: 0,
                              step: 0.01,
                              "string-mode": "",
                              onChange: preloadAmountChange
                            }, null, 8, ["value", "step"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 8 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_card, {
                  style: {"height":"200px"},
                  title: "接单费"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form, {
                      model: _unref(item),
                      autoComplete: "off",
                      ref: "refProcessForm"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: "请输入金额",
                          name: "name"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input_number, {
                              value: _unref(item).amount,
                              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(item).amount) = $event)),
                              style: {"width":"200px"},
                              defaultValue: 0,
                              precision: 2,
                              min: 0,
                              step: 0.01,
                              "string-mode": "",
                              onChange: amountChange
                            }, null, 8, ["value", "step"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, {
                          label: "付款方",
                          name: "name"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_group, {
                              value: _unref(item).paySubject,
                              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(item).paySubject) = $event)),
                              onChange: paySubjectChange
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_radio, { value: 'CLINIC' }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("诊所")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_radio, { value: 'DENTIST' }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("医生")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})